import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, signOut } from '@angular/fire/auth';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    imports: []
})
export class LogoutComponent implements OnInit {

  private auth = inject(Auth);

  constructor(private router: Router) { }

  ngOnInit() {
    signOut(this.auth).then(() => {
      this.router.navigate(['/login']);
    });
  }

}
